import { z } from "zod";
import { offsetPaginatedResponseSchema } from "../pagination.js";
/**
 * Admin dashboard contracts. Every endpoint behind these schemas is gated by
 * requireAdmin on the server; nothing here is reachable by a normal user.
 */
// ── Metrics ──────────────────────────────────────────────────────────────
export const adminMetricsResponseSchema = z.object({
    totalUsers: z.number().int(),
    // Distinct users with a live session (sessions.expire > now()). This is the
    // agreed definition of "active" — there is no separate login-tracking column.
    activeUsers: z.number().int(),
    suspendedUsers: z.number().int(),
    newUsersLast30d: z.number().int(),
    // Process uptime of the API instance that answered this request. The API runs
    // multiple instances behind an ALB, so this is per-instance, not cluster-wide.
    uptimeSeconds: z.number().int(),
    startedAt: z.string().datetime(),
});
// ── User rows ────────────────────────────────────────────────────────────
export const adminUserListItemSchema = z.object({
    id: z.string(),
    email: z.string().email(),
    name: z.string().nullable(),
    isAdmin: z.boolean(),
    suspendedAt: z.string().nullable(),
    createdAt: z.string(),
});
export const adminUsersListResponseSchema = offsetPaginatedResponseSchema(adminUserListItemSchema);
/** Detail view adds owned-resource counts for operator context. */
export const adminUserDetailSchema = adminUserListItemSchema.extend({
    updatedAt: z.string(),
    counts: z.object({
        contacts: z.number().int(),
        households: z.number().int(),
        lists: z.number().int(),
    }),
});
// ── Mutations ────────────────────────────────────────────────────────────
export const createAdminUserBodySchema = z.object({
    email: z.string().email(),
    name: z.string().min(1).max(200).optional(),
    isAdmin: z.boolean().optional(),
});
/**
 * Response to account creation. `generatedPassword` is the one and only time
 * the password is exposed in cleartext — the admin conveys it out-of-band.
 */
export const createAdminUserResponseSchema = z.object({
    user: adminUserDetailSchema,
    generatedPassword: z.string(),
});
/** Partial profile edit. Suspension is a separate endpoint (it has side effects). */
export const updateAdminUserBodySchema = z
    .object({
    name: z.string().min(1).max(200).nullable(),
    email: z.string().email(),
    isAdmin: z.boolean(),
})
    .partial();
//# sourceMappingURL=admin.js.map